import React, { createContext, useEffect, useState, useRef, useCallback} from 'react';
const WebSocketContext = createContext();
import { useHistory, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import dayjs from 'dayjs';
import { logoutService } from '@/infra/auth';
import { getUser } from '@/services/user';
import { getAuthToken } from '@/infra/auth';
import {
    getTodayQuoteList
} from '@/services/api/QuoteService';
const useGetState = (initValue) => {
    const [state, setState] = useState(initValue);
    const stateRef = useRef(state);
    stateRef.current = state;
    const getState = useCallback(() => stateRef.current, []);
    return [state, setState, getState];
};
const strument = JSON.parse(localStorage.getItem('strument') || '[]')
const bottomData = {
  1: '多开',
  2: '空开',
  3: '双开',
  4: '多换',
  5: '空换',
  6: '双换',
  7: '多平',
  8: '空平',
  9: '双平'
}
let loginedArr = JSON.parse(localStorage.getItem('logined') || '[]')
import {
  cusSuccessMessage,
  cusErrorMessage
} from '@/const/message'
let enumTypeArr = JSON.parse(localStorage.getItem('enumTypeAll')|| '[]')

export const WebSocketProvider = ({ children }) => {
    const location = useLocation()
    const navigate = useNavigate();
    const [logined, setLogined]  = useState(loginedArr);
    const [messages, setMessages] = useState({});
    const [loginStatus, setLoginStatus] = useState(false);
    const [inventory, setInventory] = useState([]);
    const [data4101All, setData4101All] = useState(JSON.stringify([]));
    const [instruction, setInstruction] = useState(JSON.stringify([]));
    const [positions, setPositions] = useState(JSON.stringify([]));
    const [allTimeObserve, setAllTimeObserve] = useState(true);
    const [timeObserve, setTimeObserve] = useState([]);
    const [timeObserve222, setTimeObserve222] = useState([]);
    const [timeObserve11005, setTimeObserve11005] = useState([]);
    const [timeObserve110052, setTimeObserve110052] = useState([]);
    const [initHisData, setInitHisData, getInitHisData] = useGetState([])
    const [taDetail, setTaDetail] = useState({
      AccountId: '',
      Balance: 0,
      Available: 0,
      PositionProfit: 0,
      CloseProfit: 0,
      CurrMargin: 0,
      Commission: 0
    });
    const [tableData, setTableData, getTableData] = useGetState(JSON.stringify([]));
    const [socket, setSocket] = useState(null);
    const [open, setOpen] = useState(false);
    const [codes, setCodes, getCodes] = useGetState([]);
    const [market9001, setMarket9001, getMarket9001] = useGetState([]);
    const [market9007, setMarket9007] = useState(JSON.stringify([]));
    const [market11007, setMarket11007] = useState(JSON.stringify([]));
    const [market13003, setMarket13003] = useState(JSON.stringify([]));
    const [market13005, setMarket13005] = useState(JSON.stringify([]));
    const [data9117, setData9117] = useState(JSON.stringify({}));
    const [data11117, setData11117] = useState(JSON.stringify({}));
    const [data2127, setData2127] = useState(JSON.stringify([]));
    const [data21271, setData21271] = useState(JSON.stringify({}));
    const [data21272, setData21272] = useState(JSON.stringify({}));
    const [data21273, setData21273] = useState(JSON.stringify({}));
    const [priceTemp, setPriceTemp, getPriceTemp] = useGetState([]);
    const [historyData, setHistoryData, getHistoryData] = useGetState([]);
    const [todayQuoteList, setTodayQuoteList, getQuoteList] = useGetState([]);
    const [quotType, setQuotTypeSocket, getQuotType] = useGetState('');
    const [contractNameCur, setContractNameCur, getContractNameCur] = useGetState('');
    const [contractCur, setContractCur, getContractCur] = useGetState('');
    const [leftBottomSource, setLeftBottomSource, getLeftBottomSource] = useGetState([]);
    const [leftBottomData, setLeftBottomData] = useState({});
    const [leftBottomData2, setLeftBottomData2] = useState({});
    const [market5003Obj, set5003Obj, get5003Obj] = useGetState({});
    const [market5006, set5006Obj, get5006Obj] = useGetState({});
    const [data10101, setData10101] = useState([]);
    const [market9006, set9006Obj, get9006Obj] = useGetState(JSON.stringify({}));
    const [data10101Arr, setData10101Arr] = useState(JSON.stringify([]));
    const [data4104Line1, setData4104Line1] = useState(JSON.stringify([]));
    const [data4104Line2, setData4104Line2] = useState(JSON.stringify([]));
    const [data4104Line3, setData4104Line3] = useState(JSON.stringify([]));
    const [data4104All, setData4104All] = useState(JSON.stringify([]));
    const [data4105Line1, setData4105Line1] = useState(JSON.stringify([]));
    const [data4105Line2, setData4105Line2] = useState(JSON.stringify([]));
    const [data4105Line3, setData4105Line3] = useState(JSON.stringify([]));
    const [data4105List1, setData4105List1] = useState([]);
    const [data4105List7, setData4105List7] = useState([]);
    const [data4107List, setData4107List] = useState([]);
    const [data4107List5, setData4107List5] = useState(JSON.stringify([]));
    const [data4107All, setData4107All] = useState(JSON.stringify([]));
    const [data2109Line, setData2109Line, getData2109Line] = useGetState(JSON.stringify({time: '',data: []}));
    const [data9107Line, setData9107Line, getData9107Line] = useGetState(JSON.stringify({time: '',data: []}));
    const [data2111, setData2111, getData2111] = useGetState(JSON.stringify([]));
    const [data6103List, setData6103List] = useState(JSON.stringify([]));
    const [data6104List, setData6104List] = useState(JSON.stringify([]));
    const [data4109List, setData4109List] = useState(JSON.stringify([]));
    const [data9101List, setData9101List] = useState(JSON.stringify([]));
    const [data9109List, setData9109List] = useState(JSON.stringify([]));
    const [data2117List, setData2117List] = useState(JSON.stringify([]));
    const [data3101List, setData3101List] = useState(JSON.stringify([]));
    const [data3102List, setData3102List] = useState(JSON.stringify([]));
    const [data4113List, setData4113List] = useState(JSON.stringify([]));
    const [data4113Data, setData4113Data] = useState(JSON.stringify({}));
    const [data4115List, setData4115List] = useState(JSON.stringify([]));
    const [data4117List, setData4117List] = useState(JSON.stringify([]));
    const [data8007List, setData8007List] = useState(JSON.stringify([]));
    const [data2131List, setData2131List] = useState(JSON.stringify([]));
    const [data4110Obj, setData4110Obj] = useState(JSON.stringify({}));
    const [data2113List, setData2113List] = useState(JSON.stringify([]));
    const [data2143List, setData2143List] = useState(JSON.stringify([]));
    const [data4111List, setData4111List] = useState(JSON.stringify([]));
    const [data12005List, setData12005List] = useState(JSON.stringify([]));
    const [position02, setPosition02] = useState([]);
    const [position04, setPosition04] = useState([]);
    const [position08, setPosition08] = useState([]);
    const [maxNum08, setMaxNum08] = useState('')
    const [timers, setTimers] = useState('');
    const clearInstruction = () => setInstruction(JSON.stringify([]))
    const [data8006, setData8006] = useState('');
    // 13001/13101 时序分析接口
    // market13101: { [reqId]: [{BusiDate, Value, ValueQ, Price}] }，一个品种完成后更新对应key
    const [market13101, setMarket13101, getMarket13101] = useGetState({});
    const market13101BufferRef = useRef({}); // { [reqId]: { total, buf[] } }
    const clearMarket13101 = () => {
      setMarket13101({});
      market13101BufferRef.current = {};
    };
    // 13007/13107 时序实时订阅：{ [Instrument]: {Value, ValueQ, Price, T} }
    const [market13107, setMarket13107] = useState({});
    const clearMarket13107 = () => setMarket13107({});
    // 13009/13109 标的行情实时订阅：{ [VID_ID1_ID2]: {VID,ID1,ID2,LP,PP} }
    const [market13109, setMarket13109] = useState({});
    const clearMarket13109 = () => setMarket13109({});

    const selectedContract = (value) => {
      setContractCur(value.Futures_Contract)
      setContractNameCur(value.InstrumentName)
    }
    const clearTimeObserve = () => setTimeObserve([])
    const clearTimeObserve11005 = () => setTimeObserve11005([])
    const clear2113List = () => setData2113List(JSON.stringify([]))
    const clear2143List = () => setData2143List(JSON.stringify([]))
    const clear2127List = () => setData2127(JSON.stringify([]))
    const clear21271 = () => setData21271(JSON.stringify({}))
    const clear21272 = () => setData21272(JSON.stringify({}))
    const clear21273 = () => setData21273(JSON.stringify({}))
    const clear12005List = () => setData12005List(JSON.stringify([]))
    const clearMarket9001 = (e) => setMarket9001(e)
    const clearMarket9007 = () => setMarket9007(JSON.stringify([]))
    const clearMarket11007 = () => setMarket11007(JSON.stringify([]))
    const clearMarket13003 = () => setMarket13003(JSON.stringify([]))
    const clearMarket13005 = () => setMarket13005(JSON.stringify([]))
    const clearLine9107 = () => setData9107Line(JSON.stringify({time: '',data: []}))
    const clearTimeObserve222 = () => setTimeObserve222([])
    const clearTimeObserve110052 = () => setTimeObserve110052([])
    const clear5003Obj = () => set5003Obj({})
    const setTableDataAction = (values) => setTableData(values)
    const clearHistoryData = () => setHistoryData([])
    const clearData10101 = () => setData10101([])
    const clearData10101Arr = () => setData10101Arr(JSON.stringify([]))
    const tableDataFilter = (InstrumentID) => {
      setTableData((prev, index) => {
        let prevArr = JSON.parse(prev)
        prevArr = prevArr.filter((item) => item.InstrumentID != InstrumentID)

        return JSON.stringify(prevArr)
      })
    }
    const clearTableData = () => setTableData(JSON.stringify([]))
    const clearData3101List = () => setData3101List(JSON.stringify([]))
    const clearData3102List = () => setData3102List(JSON.stringify([]))
    const clearData4107All = () => setData4107All(JSON.stringify([]))
    const clearData2111 = () => setData2111(JSON.stringify([]))
    const clearData610304 = () => {
      setData6103List(JSON.stringify([]))
      setData6104List(JSON.stringify([]))
    }
    const clearAllLine = () => {
      setData4104Line1(JSON.stringify([]))
      setData4104Line2(JSON.stringify([]))
      setData4104Line3(JSON.stringify([]))
      setData4104All(JSON.stringify([]))
      setData4105Line1(JSON.stringify([]))
      setData4105Line2(JSON.stringify([]))
      setData4105Line3(JSON.stringify([]))
      setData4105List1([])
      setData4105List7([])
      setData2109Line(JSON.stringify({time: '',data: []}))
      setData9107Line(JSON.stringify({time: '',data: []}))
      setData4107List([])
      setInventory([])
      setData4101All(JSON.stringify([]))
      setData4107All(JSON.stringify([]))
      setData4109List(JSON.stringify([]))
    }
    const clearData9101List = () => {
      setData9101List(JSON.stringify([]))
    }
    const clearStructureLine = () => {
      setData4104Line1(JSON.stringify([]))
      setData4104Line2(JSON.stringify([]))
    }
    const clear4113Data = () => {
      setData4113List(JSON.stringify([]))
      setData4115List(JSON.stringify([]))
      setData4117List(JSON.stringify([]))
      setData8006('')
      setData8007List(JSON.stringify([]))
      setData2131List(JSON.stringify([]))
      setData4111List(JSON.stringify([]))
    }
    const clearData4109All = () => {
      setData4109List(JSON.stringify([]))
    }
    const clearData9109 = () => setData9109List(JSON.stringify([]))
    const clearData2117 = () => setData2117List(JSON.stringify([]))
    const clearLeftBottomData = () => {
      setLeftBottomData({})
      setLeftBottomData2({})
      setLeftBottomSource([])
    }
    const clearMessages = () => setMessages({
      chHead: {
        cmMess: 0,
        iRequestId: 0
      }
    })
    const colorClassName = (value, value2) => {
      return value === 0?'':
        value > value2?'rise-price':
        value < value2?'fall-price':''
    }
    const isJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    useEffect(() => {
      setInventory([])
      setData4101All(JSON.stringify([]))
      setInstruction(JSON.stringify([]))

      if (location.pathname === '/instrument_ana/t_instrument_ana') {
        getTodayQuoteList().then(({ success, data }) => {
          const arrs = []
          const resData = []
          data.forEach((item, i) => {
            if (!arrs.includes(item.contract_Code)) {
              arrs.push(item.contract_Code)
              resData.push({
                  ...item,
                  label: item.contract_Name,
                  value: item.contract_Code,
              })
            }
          });
          setTodayQuoteList(resData);
        })
      }
    }, [location.pathname])

    useEffect(() => {
        let address = localStorage.getItem('socket_address');

        if (!address) return
        const ws = new WebSocket(address);
        let heartbeatInterval
        ws.onopen =  function (e) {
            setOpen(true)
            heartbeatInterval = setInterval(() => {
              if (getAuthToken()) {
                ws.send('ping'); // 发送ping消息
              } else {
                clearInterval(heartbeatInterval)
              }
            }, 30000);
        };

        ws.onmessage = (event) => {
            if (!isJsonString(event.data)) {
              return
            }
            const message = JSON.parse(event.data);



            if (message.chHead?.cmMess === 3002 && message.err_Code === 0) {
              setLogined(prev => prev.concat(message.strUser))
            }

            if ((message.chHead?.cmMess === 3010 || message.chHead?.cmMess === 3012 || message.chHead?.cmMess === 3014 || message.chHead?.cmMess === 3016) && message.strErr) {
              cusErrorMessage(message.strErr)
            }

            if (message.chHead?.cmMess === 12005) {
              setAllTimeObserve(message?.iCurrentPack === message?.iTotalPack)
              setData12005List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.T1 + item.T2 === message.T1 + message.T2)
                if (cur > -1) {
                  prevArr[cur] = message.Coefficient
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message.Coefficient,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 4111) {
              setData4111List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.SubContractCode === message.SubContractCode)
                if (cur > -1) {
                  prevArr[cur] = message
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 4113) {
              message.timer = moment().valueOf()
              setData4113Data(JSON.stringify(message))

              setData4113List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.TradeId.trim() + item.Busi_Date === message.TradeId.trim() + message.Busi_Date)
                if (cur > -1) {
                  prevArr[cur] = message
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 4115) {
              setData4115List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.Sub_Contract_code === message.Sub_Contract_code)
                if (cur > -1) {
                  prevArr[cur] = message
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 4110) {
              setData4110Obj(JSON.stringify({
                ...message,
                timer: dayjs().valueOf()
              }))
            }

            if (message.chHead?.cmMess === 4117) {
              setData4117List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.Sub_Contract_code === message.Sub_Contract_code)
                if (cur > -1) {
                  prevArr[cur] = message
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 8007) {
              setData8007List(prev => {
                let prevArr = JSON.parse(prev)
                prevArr = message.scRealSettle.map(item => {
                  return {
                    SubContractCode: item.SubContractCode,
                    Contract_Code: item.Contract_Code,
                    Qty: item.Qty,
                    tiemr: dayjs().valueOf()
                  }
                })
                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 9006) {

              set9006Obj(JSON.stringify(message.oiperiod))
            }

            if (message.chHead?.cmMess === 2113) {
              setData2113List(prev => {
                let prevArr = JSON.parse(prev)
                const findIndex = prevArr.findIndex(item => item.ID === message.cqQuot.ID)
                message.cqQuot.timer = dayjs().valueOf()
                if (findIndex > -1) {
                  prevArr[findIndex] = message.cqQuot
                } else {
                  prevArr.push(message.cqQuot)
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 2143) {
              setData2143List(prev => {
                let prevArr = JSON.parse(prev)
                const findIndex = prevArr.findIndex(item => item.ID1 + item.ID2 === message.cqQuot.ID1 + message.cqQuot.ID2)
                message.cqQuot.timer = dayjs().valueOf()
                if (findIndex > -1) {
                  prevArr[findIndex] = message.cqQuot
                } else {
                  prevArr.push(message.cqQuot)
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 2131) {
              setData2131List(prev => {
                let prevArr = JSON.parse(prev)
                const findIndex = prevArr.findIndex(item => item.InstrumentID === message.cqQuot.InstrumentID)
                message.cqQuot.timer = dayjs().valueOf()
                if (findIndex > -1) {
                  prevArr[findIndex] = message.cqQuot
                } else {
                  prevArr.push(message.cqQuot)
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 6103) {
              setData6103List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.CreateTime+item.StrategyID === message.item?.CreateTime+message.item?.StrategyID)
                if (cur > -1) {
                  prevArr[cur] = message.item
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message.item,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })

              if (message.item?.Status === 6) {
                setData6103List(prev => {
                  let prevArr = JSON.parse(prev)
                  return JSON.stringify(prevArr.filter(item => item.CreateTime+item.StrategyID !== message.item?.CreateTime+message.item?.StrategyID))
                })
              }
            }

            if (message.chHead?.cmMess === 6104) {
              setData6104List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.CreateTime+item.StrategyID === message.item?.CreateTime+message.item?.StrategyID)
                if (cur > -1) {
                  prevArr[cur] = message.item
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message.item,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })

              if (message.item?.Status === 6) {
                setData6104List(prev => {
                  let prevArr = JSON.parse(prev)
                  return JSON.stringify(prevArr.filter(item => item.CreateTime+item.StrategyID !== message.item?.CreateTime+message.item?.StrategyID))
                })
              }
            }

            if (message.chHead?.cmMess === 3031 && message.chHead?.iRequestId === 2) {
              const str = message.ipDetail.TodayPosition.toString().replace(/[^0-9.]/g, '')

              setPosition02(prev => {
                prev[message.ipDetail.PosiDate - 1] = {
                  positionForzon: Math.round(str) - Math.round(message.ipDetail.Frozen),
                  todayPosition: Math.round(str),
                  yPosition: Math.round(message.ipDetail.YPosition),
                  positionForzonY: Math.round(message.ipDetail.YPosition) - Math.round(message.ipDetail.Frozen)
                }
                return prev
              })
            }

            if (message.chHead?.cmMess === 3031 && message.chHead?.iRequestId === 4) {
              const str = message.ipDetail.TodayPosition.toString().replace(/[^0-9.]/g, '')
              setPosition04(prev => {
                prev[message.ipDetail.PosiDate - 1] = {
                  positionForzon: Math.round(str) - Math.round(message.ipDetail.Frozen),
                  todayPosition: Math.round(str),
                  yPosition: Math.round(message.ipDetail.YPosition),
                  positionForzonY: Math.round(message.ipDetail.YPosition) - Math.round(message.ipDetail.Frozen)
                }
                return prev
              })
            }

            if (message.chHead?.cmMess === 3031 && message.chHead?.iRequestId === 8) {
              const str = message.ipDetail.TodayPosition.toString().replace(/[^0-9.]/g, '')
              setPosition08(prev => {
                prev[message.ipDetail.PosiDate - 1] = {
                  positionForzon: Math.round(str) - Math.round(message.ipDetail.Frozen),
                  todayPosition: Math.round(str),
                  yPosition: Math.round(message.ipDetail.YPosition),
                  positionForzonY: Math.round(message.ipDetail.YPosition) - Math.round(message.ipDetail.Frozen)
                }
                return prev
              })

              setMaxNum08(prev => {
                prev = Number(prev || 0) + Math.round(str) + Math.round(message.ipDetail.YPosition)

                return prev
              })
            }

            if (message.chHead?.cmMess === 9117) {
              setData9117(JSON.stringify(message.basisdetail))
            }

            if (message.chHead?.cmMess === 11117) {
              setData11117(JSON.stringify(message.basisdetail))
            }

            if (message.chHead?.cmMess === 2127) {
              message.CrossQuote.timer = dayjs().valueOf()
              if (message.CrossQuote.T.includes('idx')) {
                setData21271(JSON.stringify(message.CrossQuote))
              } else if (message.CrossQuote.T.includes('USDCNY')) {
                setData21272(JSON.stringify(message.CrossQuote))
              } else {
                setData21273(JSON.stringify(message.CrossQuote))
              }
            }

            if (message.chHead?.cmMess === 4109) {
              setData4109List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.OrgId === message.OrgId)
                if (cur > -1) {
                  prevArr[cur] = message
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }



            if (message.chHead?.cmMess === 5003) {
              const item = message.item
              const obj = get5003Obj()
              if (!obj[item.OrgId]) obj[item.OrgId] = {}
              if (!obj[item.OrgId][item.Term]) obj[item.OrgId][item.Term] = [0,0,0,0,0,0]

              if (item.Risk_Type === 1) {
                obj[item.OrgId][item.Term][0] = item.Value
              } else if (item.Risk_Type === 2) {
                obj[item.OrgId][item.Term][1] = item.Value
              } else if (item.Risk_Type === 3) {
                obj[item.OrgId][item.Term][2] = item.Value
              } else if (item.Risk_Type === 4) {
                obj[item.OrgId][item.Term][3] = item.Value
              } else if (item.Risk_Type === 11) {
                obj[item.OrgId][item.Term][4] = item.Value
              } else if (item.Risk_Type === 5) {
                obj[item.OrgId][item.Term][5] = item.Value
              }
              obj[item.OrgId][item.Term][6] = item.Commodity_code
            }

            if (message.chHead?.cmMess === 5006) {
              const item = message.item
              const obj = get5006Obj()
              if (!obj[item.OrgId]) obj[item.OrgId]= [0,0,0,0,0,0,0,0,0,0,0]
              // obj[item.OrgId][0] =
            }

            if (message.chHead?.cmMess === 10101) {
              setData10101((prev) => prev.concat([message?.item]))
              setData10101Arr(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.date === moment(message.item.busi_date).format('YYYY.MM'))
                if (cur > -1) {
                  prevArr[cur].PLA += message.item.PLA
                  prevArr[cur].PLB += message.item.PLB
                  prevArr[cur].PLC += message.item.PLC
                  prevArr[cur].basiPLA += message.item.basiPLA
                  prevArr[cur].basiPLB += message.item.basiPLB
                  prevArr[cur].basiPLC += message.item.basiPLC
                  prevArr[cur].exposurePLA += message.item.exposurePLA
                  prevArr[cur].exposurePLB += message.item.exposurePLB
                  prevArr[cur].exposurePLC += message.item.exposurePLC
                  prevArr[cur].taxPLA += message.item.taxPLA
                  prevArr[cur].taxPLB += message.item.taxPLB
                  prevArr[cur].taxPLC += message.item.taxPLC

                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    PLA: message.item.PLA,
                    PLB: message.item.PLB,
                    PLC: message.item.PLC,
                    basiPLA: message.item.basiPLA,
                    basiPLB: message.item.basiPLB,
                    basiPLC: message.item.basiPLC,
                    exposurePLA: message.item.exposurePLA,
                    exposurePLB: message.item.exposurePLB,
                    exposurePLC: message.item.exposurePLC,
                    taxPLA: message.item.taxPLA,
                    taxPLB: message.item.taxPLB,
                    taxPLC: message.item.taxPLC,
                    date: moment(message.item.busi_date).format('YYYY.MM'),
                    busi_date: message.item.busi_date,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 9101 && message.cqBasis?.T1 === 'cu_0') {
              let prevv = [...getMarket9001()]
              const hasData = prevv.map(item => item.T2)
              if (hasData.includes(message?.cqBasis.T2)) {
                prevv.forEach((item, i) => {
                  if (item.T2 === message?.cqBasis.T2) {
                    item = message?.cqBasis
                  }
                });
              } else {
                prevv.unshift(message?.cqBasis)
              }
              setMarket9001(prevv)
            }

            if (message.chHead?.cmMess === 9101) {
              setData9101List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.G === message.cqBasis.G)
                prevArr.unshift({
                  ...message.cqBasis,
                  timer: moment().valueOf()
                })

                if (prevArr.length > 50) {
                  prevArr.length = 50
                }

                return JSON.stringify(prevArr)
              })

              // setData9101List(prev => {
              //   let prevArr = JSON.parse(prev)
              //   return JSON.stringify(prevArr.filter(item => item.G > moment().subtract(60, 'seconds').format('HH:mm:ss')))
              // })
            }

            if (message.chHead?.cmMess === 2117) {
              setData2117List(prev => {
                let prevArr = JSON.parse(prev)
                const fIndex = prevArr.findIndex(item => item.Quote_Type === message.cqQuot.Quote_Type)
                message.cqQuot.timer = moment().valueOf()
                if (fIndex > -1) {
                  prevArr[fIndex] = message.cqQuot
                } else {
                  prevArr.push(message.cqQuot)
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 9109) {
              setData9109List(prev => {
                let prevArr = JSON.parse(prev)

                message.cqBasis.timer = moment().valueOf()
                prevArr.push(message.cqBasis)

                if (prevArr.length > 11) {
                  prevArr = prevArr.slice(-11)
                }

                return JSON.stringify(prevArr)
              })

              // setData9101List(prev => {
              //   let prevArr = JSON.parse(prev)
              //   return JSON.stringify(prevArr.filter(item => item.G > moment().subtract(60, 'seconds').format('HH:mm:ss')))
              // })
            }

            if (message.chHead?.cmMess === 9005 && message.chHead?.iRequestId === 221) {
              setAllTimeObserve(message?.iCurrentPack === message?.iTotalPack)
              if (message?.basisdetail?.BD) {
                setTimeObserve((prev) => prev.concat([message?.basisdetail]))
              }
            }

            if (message.chHead?.cmMess === 9005 && message.chHead?.iRequestId === 222) {
              setAllTimeObserve(message?.iCurrentPack === message?.iTotalPack)
              setTimeObserve222((prev) => prev.concat([message?.basisdetail]))
            }

            if (message.chHead?.cmMess === 11005 && message.chHead?.iRequestId === 221) {
              setAllTimeObserve(message?.iCurrentPack === message?.iTotalPack)
              if (message?.basisdetail?.BD) {
                setTimeObserve11005((prev) => prev.concat([message?.basisdetail]))
              }
            }

            if (message.chHead?.cmMess === 11005 && message.chHead?.iRequestId === 222) {
              setAllTimeObserve(message?.iCurrentPack === message?.iTotalPack)
              setTimeObserve110052((prev) => prev.concat([message?.basisdetail]))
            }


            if (message.chHead?.cmMess === 13103) {
              setMarket13003(prev => {
                let prevArr = JSON.parse(prev)
                const dd = message
                const cur = prevArr.findIndex(item => item.VID === dd.VID && item.ID === dd.ID)
                if (cur > -1) {
                  prevArr[cur] = dd
                  prevArr[cur].timer = moment().valueOf()+''
                } else {
                  prevArr = prevArr.concat([{
                    ...dd,
                    timer: moment().valueOf()+''
                  }])
                }
                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 13105) {
              setMarket13005(prev => {
                let prevArr = JSON.parse(prev)
                const dd = message
                const cur = prevArr.findIndex(item => item.VID === dd.VID && item.ID === dd.ID)
                if (cur > -1) {
                  prevArr[cur] = dd
                  prevArr[cur].timer = moment().valueOf()+''
                } else {
                  prevArr = prevArr.concat([{
                    ...dd,
                    timer: moment().valueOf()+''
                  }])
                }
                return JSON.stringify(prevArr)
              })
            }

            // 13107：时序实时推送，按 Instrument 更新最新数据点
            if (message.chHead?.cmMess === 13107) {
              const inst = message.Instrument;
              if (inst) {
                setMarket13107(prev => ({
                  ...prev,
                  [inst]: {
                    Value: message.Value,
                    ValueQ: message.ValueQ,
                    Price: message.Price,
                    T: message.T || dayjs().format('HH:mm:ss'),
                  }
                }));
              }
            }

            // 13109：标的行情实时推送，按 VID+ID1+ID2 更新
            if (message.chHead?.cmMess === 13109) {
              const key = `${message.VID}_${message.ID1}_${message.ID2}`;
              setMarket13109(prev => ({
                ...prev,
                [key]: {
                  VID: message.VID,
                  ID1: message.ID1,
                  ID2: message.ID2,
                  LP: message.Quote?.LP,
                  PP: message.Quote?.PP,
                }
              }));
            }

            // 13101：时序分析推送（按 iRequestId 分品种缓冲，全部到达后更新state）
            if (String(message.chHead?.cmMess) === '13101') {
              const total = message.iTotalPack ?? message.chHead?.iTotalPack;
              const current = message.iCurrentPack ?? message.chHead?.iCurrentPack;
              const reqId = String(message.chHead?.iRequestId ?? 'default');
              console.log('[WS-13101] 收到数据 reqId:', reqId, 'current:', current, 'total:', total);
              if (!market13101BufferRef.current[reqId]) {
                market13101BufferRef.current[reqId] = { total: 0, buf: [] };
              }
              if (message.ind) {
                if (Array.isArray(message.ind)) {
                  market13101BufferRef.current[reqId].buf.push(...message.ind);
                } else {
                  market13101BufferRef.current[reqId].buf.push(message.ind);
                }
              }
              market13101BufferRef.current[reqId].total = total;
              const curNum = Number(current);
              const totNum = Number(total);
              if (curNum === totNum && total != null) {
                const allData = [...market13101BufferRef.current[reqId].buf];
                market13101BufferRef.current[reqId] = { total: 0, buf: [] };
                setMarket13101(prev => ({ ...prev, [reqId]: allData }));
              }
            }

            // 13002：时序历史查询应答，flush 所有待处理的 13101 缓冲
            if (message.chHead?.cmMess === 13002) {
              const buffers = market13101BufferRef.current;
              Object.keys(buffers).forEach(reqId => {
                if (buffers[reqId].buf.length > 0) {
                  console.log('[WS-13002] flush reqId:', reqId, '数据条数:', buffers[reqId].buf.length);
                  const allData = [...buffers[reqId].buf];
                  buffers[reqId] = { total: 0, buf: [] };
                  setMarket13101(prev => ({ ...prev, [reqId]: allData }));
                }
              });
            }

            // 13004：比价订阅-A 应答，不处理时序数据

            if (message.chHead?.cmMess === 9107) {
              setMarket9007(prev => {
                let prevArr = JSON.parse(prev)
                const dd = message.cqBasisQuantile
                const cur = prevArr.findIndex(item => item.T1 === dd.T1 && item.T2 === dd.T2)
                if (cur > -1) {
                  prevArr[cur] = message.cqBasisQuantile
                  prevArr[cur].timer = moment().valueOf()+''
                } else {
                  prevArr = prevArr.concat([{
                    ...message.cqBasisQuantile,
                    timer: moment().valueOf()+''
                  }])
                }
                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 11107) {
              setMarket11007(prev => {
                let prevArr = JSON.parse(prev)
                const dd = message.cqBasisQuantile
                const cur = prevArr.findIndex(item => item.T1 === dd.T1 && item.T2 === dd.T2)
                if (cur > -1) {
                  prevArr[cur] = message.cqBasisQuantile
                  prevArr[cur].timer = moment().valueOf()+''
                } else {
                  prevArr = prevArr.concat([{
                    ...message.cqBasisQuantile,
                    timer: moment().valueOf()+''
                  }])
                }
                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 2107) {
              const temp = getLeftBottomSource() || []
              const nowMinusOneMinute = moment().subtract(1, 'minutes')
              const tempNew = temp.filter((item) => {
                const genTime = moment(item.GenTime, "HH:mm:ss")
                if (genTime.isAfter(nowMinusOneMinute)) {
                  return item
                }
              })

              tempNew.unshift({
                GenTime: message.cqQuot.GenTime,
                CurrVolume: message.cqQuot.CurrVolume,
                LastPrice: message.cqQuot.LastPrice,
                Interest: message.cqQuot.Interest2,
                BS_FlagPlus: bottomData[message.cqQuot.BS_FlagPlus],
                bsf: message.cqQuot.BS_FlagPlus,
                ico: colorClassName(message.cqQuot.Interest2,tempNew[0]?.Interest2),
              })

              setLeftBottomSource(tempNew)
              setLeftBottomData(message.cqQuot)
            }

            if (message.chHead?.cmMess === 1002 && !message.strErr) {
              setLoginStatus(true)
              let selectedKeys = JSON.parse(localStorage.getItem('selectedKeys')|| '[]')


              if (!enumTypeArr.length) {
                setTimeout(() => {
                  window.location.reload()
                })

              }

              if (selectedKeys.length) {
                navigate('/'+selectedKeys[0]);
              } else {
                navigate('/');
              }
            }

            if (message.chHead?.cmMess === 8006) {
              message.timer = dayjs().valueOf()
              setData8006(JSON.stringify(message))
            }

            if (message.chHead?.cmMess === 1002 && message.strErr) {
              cusErrorMessage('登录失效')
              logoutService().finally(() => {
                localStorage.setItem('logined', '[]')
                // 跳转到登录页面
                window.location.href = '/login';
              })
            }

            if (message.chHead?.cmMess === 3101) {
              setData3101List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.OrderSysID+item.OrderRef === message.ordDetail?.OrderSysID+message.ordDetail?.OrderRef)
                if (cur < 0) {
                  prevArr.unshift({
                    ...message.ordDetail,
                    timer: moment().valueOf()
                  })
                } else {
                  prevArr[cur] = message.ordDetail
                  if (prevArr[cur]) {
                    prevArr[cur].timer = moment().valueOf()
                  }
                }

                if (prevArr.length > 50) {
                  prevArr.length = 10
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 3102) {
              setData3102List(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.TradeID + item.InstrumentID === message.traDetail.TradeID + message.traDetail.InstrumentID)
                if (cur < 0) {
                  prevArr.unshift({
                    ...message.traDetail,
                    timer: moment().valueOf()
                  })
                } else {
                  prevArr[cur] = message.traDetail
                  prevArr[cur].timer = moment().valueOf()
                }

                if (prevArr.length > 50) {
                  prevArr.length = 10
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 3106) {
              setTaDetail(message?.taDetail)
            }

            if (message.chHead?.cmMess === 3107) {
              setPositions(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.AccountId+item.InstrumentID+item.Direction+item.HedgeFlag === message.posiDetail?.AccountId+message.posiDetail?.InstrumentID+message.posiDetail?.Direction+message.posiDetail?.HedgeFlag)
                if (cur > -1) {
                  prevArr[cur] = message.posiDetail
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message.posiDetail,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 4101) {
              setInventory((prev) => prev.concat([message]))
              setData4101All(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.Trade_Id === message.Trade_Id)
                if (cur > -1) {
                  prevArr[cur] = message
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 2111) {
              setData2111(prev => {
                let prevData = JSON.parse(prev)
                let index = prevData.findIndex(item => item.InstrumentID === message.cqQuot.InstrumentID)

                if (index < 0) {
                  message.cqQuot.timer = dayjs().valueOf()
                  prevData = prevData.concat([message.cqQuot])
                } else {
                  message.cqQuot.timer = dayjs().valueOf()
                  prevData[index] = message.cqQuot
                }
                return JSON.stringify(prevData)
              })
            }

            if (message.chHead?.cmMess === 2109) {
              setData2109Line(prev => {
                const res = JSON.parse(prev)
                const keys = res.data.map(item => item.t)
                if (!keys.includes(message.cqQuotQuantile?.T)) {
                  res.data.push({
                    t: message.cqQuotQuantile?.T,
                    qq: message.cqQuotQuantile?.QQ,
                  })
                } else {
                  const index = res.data.findIndex(item => item.t === message.cqQuotQuantile?.T)
                  res.data[index] = {
                    t: message.cqQuotQuantile?.T,
                    qq: message.cqQuotQuantile?.QQ,
                  }
                }
                res.time = moment().valueOf()
                return JSON.stringify(res)
              })
            }

            if (message.chHead?.cmMess === 9107) {
              setData9107Line(prev => {
                const res = JSON.parse(prev)
                const keys = res.data.map(item => item.t)
                if (!keys.includes(message.cqBasisQuantile?.T2)) {
                  res.data.push({
                    t: message.cqBasisQuantile?.T2,
                    bq: message.cqBasisQuantile?.BQ,
                  })
                } else {
                  const index = res.data.findIndex(item => item.t === message.cqBasisQuantile?.T2)
                  res.data[index] = {
                    t: message.cqBasisQuantile?.T2,
                    bq: message.cqBasisQuantile?.BQ,
                  }
                }
                res.time = moment().valueOf()
                return JSON.stringify(res)
              })
            }

            if (message.chHead?.cmMess === 4104) {
              setData4104All(prev => {
                const prevData = JSON.parse(prev)

                prevData.push(message)
                return JSON.stringify(prevData)
              })
            }

            if (message.chHead?.cmMess === 4104 && message.AL_Type === 1) {
              const num = Number(message.Term)
              if (message.iCurrentPack === 1) {
                setData4104Line1(JSON.stringify([]))
              }
              if (message.Busi_Type === 7) {
                setData4104Line3(prev => {
                  const prevData = JSON.parse(prev)

                  if (!prevData[num + 1]) {
                    prevData[num + 1] = {
                      Term: message.Term,
                      Qty: parseInt(message.Qty),
                      time: moment().valueOf()
                    }
                  } else {
                    prevData[num + 1].Qty = parseInt(prevData[num + 1].Qty + message.Qty)
                    prevData[num + 1].time = moment().valueOf()
                  }
                  return JSON.stringify(prevData)
                })
              }
              setData4104Line1(prev => {
                const prevData = JSON.parse(prev)

                if (!prevData[num + 1]) {
                  prevData[num + 1] = {
                    Term: message.Term,
                    Qty: parseInt(message.Qty),
                    time: moment().valueOf()
                  }
                } else {
                  prevData[num + 1].Qty = parseInt(prevData[num + 1].Qty + message.Qty)
                  prevData[num + 1].time = moment().valueOf()
                }
                return JSON.stringify(prevData)
              })
            }

            if (message.chHead?.cmMess === 4104 && message.AL_Type === 2) {
              const num = Number(message.Term)
              if (message.iCurrentPack === 1) {
                setData4104Line2(JSON.stringify([]))
              }
              setTimeout(() => {
                setData4104Line2(prev => {
                  const prevData = JSON.parse(prev)

                  if (!prevData[num + 1]) {
                    prevData[num + 1] = {
                      Term: message.Term,
                      Qty: parseInt(message.Qty),
                      time: moment().valueOf()
                    }
                  } else {
                    prevData[num + 1].Qty = parseInt(prevData[num + 1].Qty + message.Qty)
                    prevData[num + 1].time = moment().valueOf()
                  }
                  return JSON.stringify(prevData)
                })
              })

            }

            if (message.chHead?.cmMess === 4105 && message.Busi_Type === 7) {
              setData4105List7(prev => prev.concat([{
                AL_Type: message.AL_Type,
                Busi_Type: message.Busi_Type,
                Qty: message.Qty
              }]))
            }

            if (message.chHead?.cmMess === 4105 && message.Busi_Type !== 7) {
              setData4105List1(prev => prev.concat([{
                AL_Type: message.AL_Type,
                Busi_Type: message.Busi_Type,
                Qty: message.Qty
              }]))
            }

            if (message.chHead?.cmMess === 4105 && message.AL_Type === 1) {
              const num = Number(message.Term)
              setData4105Line1(prev => {
                const prevData = JSON.parse(prev)

                if (message.Busi_Type === 7) {
                  setData4105Line3(prev => {
                    const prevData = JSON.parse(prev)

                    if (!prevData[0]) {
                      prevData[0] = {
                        AL_Type: message.AL_Type,
                        Qty: message.Qty
                      }
                    } else {
                      prevData[0].Qty = parseInt(prevData[0].Qty + message.Qty)
                      prevData[0].time = moment().valueOf()
                    }

                    return JSON.stringify(prevData)
                  })
                }

                if (!prevData[0]) {
                  prevData[0] = {
                    AL_Type: message.AL_Type,
                    Qty: message.Qty
                  }
                } else {
                  prevData[0].Qty = parseInt(prevData[0].Qty + message.Qty)
                  prevData[0].time = moment().valueOf()
                }
                return JSON.stringify(prevData)
              })
            }

            if (message.chHead?.cmMess === 4105 && message.AL_Type === 2) {
              const num = Number(message.Term)
              setData4105Line2(prev => {
                const prevData = JSON.parse(prev)

                if (!prevData[0]) {
                  prevData[0] = {
                    AL_Type: message.AL_Type,
                    Qty: message.Qty
                  }
                } else {
                  prevData[0].Qty = parseInt(prevData[0].Qty + message.Qty)
                  prevData[0].time = moment().valueOf()
                }
                return JSON.stringify(prevData)
              })
            }

            if (message.chHead?.cmMess === 4107) {
              setInstruction(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.Hedging_Code === message.task?.Hedging_Code)
                if (cur > -1) {
                  prevArr[cur] = message.task
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message.task,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
              setData4107All(prev => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.Hedging_Code === message.task?.Hedging_Code)
                if (cur > -1) {
                  prevArr[cur] = message.task
                  prevArr[cur].timer = moment().valueOf()
                } else {
                  prevArr = prevArr.concat([{
                    ...message.task,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
            }

            if (message.chHead?.cmMess === 4107
              && message.task?.Busi_type === 1) {
              setData4107List((prev) => prev.concat([message.task]))
            }

            if (message.chHead?.cmMess === 2006) {
              const cqQuot = message.cqQuot

              const quoteListTemp = getQuoteList();
              const quoteTemp = quoteListTemp.find((i) => i.contract_Code === cqQuot.InstrumentID)

              if (dayjs(cqQuot.GenTime).format('MM') != dayjs().format('MM')) {
                return
              }

              cqQuot.InstrumentName = quoteTemp?.instrument_Name || '';
              cqQuot.Time = dayjs(cqQuot.GenTime).format('HHmm')


              setInitHisData(prev => {
                prev.forEach((item, i) => {
                  if (item.Time == cqQuot.Time) {
                    prev[i] = cqQuot
                  } else {
                    prev[i].InstrumentID = cqQuot.InstrumentID
                    prev[i].InstrumentName = cqQuot.InstrumentName
                  }
                });
                return prev
              })
              // console.log(getInitHisData());

              setHistoryData(getInitHisData());
            }



            if (message.chHead?.cmMess === 3031) {
              setMessages(message.timer = moment().valueOf());
            }

            if (message.chHead?.cmMess === 2101) {
              const quoteListTemp = getQuoteList();
              const quotType = getQuotType()

              // const codess = getCodes()
              const cqQuot = message.cqQuot
              const strumentFind = strument.find(
                (i) => i.contract_Code === cqQuot.InstrumentID
              )
              cqQuot.InstrumentName =
                        quoteListTemp.find(
                            (i) => i.contract_Code === cqQuot.InstrumentID,
                        )?.instrument_Name ?? '';
              if (strumentFind) {
                cqQuot.mflag = strumentFind.m_flag || '28';
                cqQuot.quote_Type = strumentFind.quote_Type;
              }

              if (getContractCur() === cqQuot.InstrumentID) {
                setLeftBottomData2(cqQuot)
                const curData = {
                  PreClosePrice: cqQuot.PreClosePrice,
                  OpenPrice: cqQuot.OpenPrice,
                  HighestPrice: cqQuot.HighestPrice,
                  LowestPrice: cqQuot.LowestPrice,
                  ClosePrice: cqQuot.LastPrice,
                  Volume: cqQuot.Volume,
                  CurrVolume: cqQuot.CurrVolume,
                  Turnover: cqQuot.Turnover,
                  OpenInterest: cqQuot.OpenInterest,
                  SettlementPrice: cqQuot.SettlementPrice || null,
                  PreSettlementPrice: cqQuot.PreSettlementPrice,
                  GenTime: '',
                  InstrumentID: cqQuot.InstrumentID,
                  InstrumentName: getContractNameCur(),
                }

                if (quotType == 100) {
                  let date = dayjs().format('YYYYMMDD') + ' ' + cqQuot.GenTime
                  setInitHisData(prev => {
                    prev.forEach((item, i) => {
                      if (item.Time == dayjs(date).format('HHmm')) {
                        prev[i].ClosePrice = cqQuot.LastPrice
                        prev[i].HighestPrice = cqQuot.HighestPrice
                        prev[i].LowestPrice = cqQuot.LowestPrice
                        prev[i].OpenInterest = cqQuot.OpenInterest
                        prev[i].OpenPrice = cqQuot.OpenPrice
                        prev[i].PreClosePrice = cqQuot.PreClosePrice
                        prev[i].Volume = cqQuot.Volume
                      }
                    });
                    return prev
                  })
                  setHistoryData([]);
                  setTimeout(() => {
                    setHistoryData(getInitHisData());
                  })

                }

                if (quotType == 1) {
                   setHistoryData(prev => {
                     if (!prev.length) return prev
                     let date = dayjs().format('YYYYMMDD') + ' ' + cqQuot.GenTime
                     const index = prev.findIndex(item => dayjs(item.GenTime).format('YYYYMMDDmm') === dayjs(date).format('YYYYMMDDmm'))
                     curData.GenTime = dayjs(date).format('YYYYMMDD HH:mm:ss')
                     curData.Time = Number(dayjs(date).format('HHmm'))

                     if (dayjs(prev[prev.length - 1].GenTime).format('YYYYMMDD') !== dayjs().format('YYYYMMDD')) {
                       curData.PreClosePrice = prev[prev.length - 1].PreClosePrice
                     }

                     if (index < 0) {
                       prev = prev.concat([curData])
                     } else {
                       prev = prev.filter((item, i) => index != i)
                       prev = prev.concat([curData])
                     }
                     return prev
                   })
                }

                if (quotType == 2 || quotType == 3 || quotType == 4) {
                  let date = dayjs().format('YYYYMMDD') + ' ' + cqQuot.GenTime
                  const parsedTime = dayjs(cqQuot.GenTime, 'HH:mm:ss');

                  const currentMinutes = parsedTime.minute();
                  const isMultipleOfFive = currentMinutes % 5 === 0;
                  if (!isMultipleOfFive && quotType == 2) {
                    const nextFiveMinuteMultiple = Math.floor(currentMinutes / 5) * 5;
                    date = parsedTime.minute(nextFiveMinuteMultiple).format('YYYYMMDD HH:mm:ss');
                  } else if (!isMultipleOfFive && quotType == 3) {
                    const nextFiveMinuteMultiple = Math.floor(currentMinutes / 15) * 15;
                    date = parsedTime.minute(nextFiveMinuteMultiple).format('YYYYMMDD HH:mm:ss');
                  } else if (!isMultipleOfFive && quotType == 4) {
                    const nextFiveMinuteMultiple = Math.floor(currentMinutes / 30) * 30;
                    date = parsedTime.minute(nextFiveMinuteMultiple).format('YYYYMMDD HH:mm:ss');
                  }
                  if (parsedTime.format('HH:mm') === '09:00' || parsedTime.format('HH:mm') === '13:30' || parsedTime.format('HH:mm') === '21:00') {
                    let dates = dayjs().format('YYYYMMDD') + ' ' + cqQuot.GenTime
                    date = dayjs(dates).seconds(0).format('YYYYMMDD HH:mm:ss')
                  }
                  setHistoryData(prev => {
                    if (!prev.length) return prev
                    const index = prev.findIndex(item => dayjs(item.GenTime).format('YYYYMMDDmm') === dayjs(date).format('YYYYMMDDmm'))
                    curData.GenTime = dayjs(date).format('YYYYMMDD HH:mm:ss')
                    curData.Time = Number(dayjs(date).format('HHmm'))

                    if (dayjs(prev[prev.length - 1].GenTime).format('YYYYMMDD') !== dayjs().format('YYYYMMDD')) {
                      curData.PreClosePrice = prev[prev.length - 1].PreClosePrice
                    }
                    if (index < 0) {
                      prev = prev.concat([curData])
                    } else {
                      prev = prev.filter((item, i) => index != i)
                      prev = prev.concat([curData])
                    }
                    return prev
                  })
                }

                if (quotType == 5 || quotType == 6
                  || quotType == 7 || quotType == 8 || quotType == 9) {
                   setHistoryData(prev => {
                     if (!prev.length) return prev
                     let date = dayjs().format('YYYYMMDD') + ' ' + cqQuot.GenTime
                     let index = prev.findIndex(item => dayjs(item.GenTime).format('YYYYMMDDmm') === dayjs(date).format('YYYYMMDDmm'))
                     curData.GenTime = dayjs(date).format('YYYYMMDD HH:mm:ss')
                     curData.Time = Number(dayjs(date).format('HHmm'))

                     if (quotType == 5) {
                        index = prev.findIndex(item => dayjs(item.GenTime, 'YYYYMMDD HH:mm:ss').format('YYYYMMDD HH') === dayjs(date).format('YYYYMMDD HH'))
                     }

                     if (quotType == 6 || quotType == 7 || quotType == 8 || quotType == 9) {
                        index = prev.findIndex(item => dayjs(item.GenTime, 'YYYYMMDD HH:mm:ss').format('YYYYMMDD') === dayjs(date).format('YYYYMMDD'))
                     }

                     if (dayjs(prev[prev.length - 1].GenTime).format('YYYYMMDD') !== dayjs().format('YYYYMMDD')) {
                       curData.PreClosePrice = prev[prev.length - 1].PreClosePrice
                     }

                     if (index < 0) {
                       prev = prev.concat([curData])
                     } else {
                       prev = prev.filter((item, i) => index != i)
                       prev = prev.concat([curData])
                     }
                     return prev
                   })
                }
              }

              let price = getPriceTemp()
              setTableData((prev, index) => {
                let prevArr = JSON.parse(prev)
                const cur = prevArr.findIndex(item => item.InstrumentID === cqQuot.InstrumentID)
                if (cur > -1) {
                  setTimeout(() => {
                    price[cur] = cqQuot.LastPrice
                    setPriceTemp(price)
                  }, 300)

                  prevArr[cur] = cqQuot
                  prevArr[cur].timer = moment().valueOf()
                } else {

                  prevArr = prevArr.concat([{
                    ...cqQuot,
                    timer: moment().valueOf()
                  }])
                }

                return JSON.stringify(prevArr)
              })
              // if (!codess.includes(message.cqQuot.InstrumentID)) {
              //   setCodes((prev) => prev.concat([message.cqQuot.InstrumentID]))
              //   setTableData((prev) => prev.concat([cqQuot]))
              // } else {
              //   let price = getPriceTemp()
              //   let index = codess.findIndex(item => item === message.cqQuot.InstrumentID)
              //   let d = [...getTableData()]
              //   d[index] = cqQuot
              //   setTimeout(() => {
              //     price[index] = message.cqQuot.LastPrice
              //     setPriceTemp(price)
              //   }, 300)
              //   setTableData(d)
              // }
            }
            setMessages(message);
        };

        ws.onerror = () => {
          console.log('WebSocket onerror');
          clearInterval(heartbeatInterval);
        }
        ws.onclose = () => {
          console.log('WebSocket onclose');
          clearInterval(heartbeatInterval);
        }

        setSocket(ws);

        return () => {
            ws.close();
        };
    }, []);

    return (
        <WebSocketContext.Provider value={{
          messages,
          socket,
          open,
          logined,
          loginStatus,
          inventory,
          instruction,
          clearInstruction,
          historyData,
          clearHistoryData,
          setHistoryData,
          todayQuoteList,
          tableData,
          setTableDataAction,
          priceTemp,
          selectedContract,
          leftBottomSource,
          leftBottomData,
          leftBottomData2,
          clearLeftBottomData,
          positions,
          setPositions,
          taDetail,
          timeObserve,
          timeObserve222,
          clearTimeObserve222,
          clearTimeObserve,
          timeObserve11005,
          timeObserve110052,
          clearTimeObserve110052,
          clearTimeObserve11005,
          market9001,
          clearMarket9001,
          market9007,
          clearMarket9007,
          market11007,
          clearMarket11007,
          market13003,
          market13005,
          clearMarket13003,
          clearMarket13005,
          clearMessages,
          market5003Obj,
          clear5003Obj,
          data10101,
          data10101Arr,
          clearData10101Arr,
          clearData10101,
          data4105Line1,
          data4105Line2,
          data4105Line3,
          data4105List1,
          data4105List7,
          data4104Line1,
          data4104Line2,
          data4104Line3,
          data4104All,
          data2109Line,
          data9107Line,
          data4107List,
          data4107List5,
          data4107All,
          clearData4107All,
          clearAllLine,
          data2111,
          data6103List,
          data6104List,
          data4109List,
          data9101List,
          data9109List,
          clearData610304,
          setQuotTypeSocket,
          tableDataFilter,
          data3101List,
          data3102List,
          data4101All,
          clearData4109All,
          clearData2111,
          clearData9109,
          clearData3101List,
          clearData3102List,
          setInitHisData,
          position08,
          maxNum08,
          setPosition08,
          setMaxNum08,
          position02,
          setPosition02,
          position04,
          setPosition04,
          data4111List,
          data4113List,
          data4115List,
          data4117List,
          clear4113Data,
          data8006,
          setData8006,
          data8007List,
          data2131List,
          data4110Obj,
          clearStructureLine,
          clearLine9107,
          clearData9101List,
          data4113Data,
          data2117List,
          clearData2117,
          data9117,
          data11117,
          allTimeObserve,
          data2113List,
          clearTableData,
          data12005List,
          clear12005List,
          clear2113List,
          data2143List,
          clear2143List,
          market9006,
          data2127,
          clear2127List,
          data21271,
          data21272,
          data21273,
          clear21271,
          clear21272,
          clear21273,
          market13101,
          clearMarket13101,
          market13107,
          clearMarket13107,
          market13109,
          clearMarket13109,
        }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    return React.useContext(WebSocketContext);
};
